import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { TestSubsection } from "./TestSection";
import { TrendingUp, Download, DollarSign, Receipt, CreditCard } from "lucide-react";
import * as tests from "./testDefinitions";

export const FinancialsSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">💰 Financials</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={TrendingUp}
          iconColor="text-green-600"
          title="Revenue"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.revenueTests}
          results={testResults.revenue}
        />
        
        <TestSubsection
          icon={Download}
          iconColor="text-blue-600"
          title="Payouts"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.payoutsTests}
          results={testResults.payouts}
        />
        
        <TestSubsection
          icon={DollarSign}
          iconColor="text-emerald-600"
          title="Account"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.accountTests}
          results={testResults.account}
        />
        
        <TestSubsection
          icon={Receipt}
          iconColor="text-purple-600"
          title="Payroll"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.payrollTests}
          results={testResults.payroll}
        />
        
        <TestSubsection
          icon={CreditCard}
          iconColor="text-indigo-600"
          title="Stripe Connect / Payments"
          badge={<Badge className="bg-orange-500 text-white text-xs">New</Badge>}
          tests={tests.stripeConnectTests}
          results={testResults.stripeConnect}
        />
      </CardContent>
    </Card>
  );
};
